// login.js
// Handles login form submission for index.html

function runLoginLogic() {
    // Forgot password logic
    const forgotBtn = document.getElementById('forgot-password-btn');
    if (forgotBtn) {
      forgotBtn.addEventListener('click', async () => {
        const email = prompt("Veuillez entrer votre adresse email pour réinitialiser votre mot de passe :");
        if (!email) return;
        try {
          const res = await fetch('/api/request-password-reset', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email })
          });
          const result = await res.json();
          if (result.success) {
            alert('Un email de réinitialisation a été envoyé si l’adresse existe.');
          } else {
            alert(result.message || 'Erreur lors de la demande de réinitialisation.');
          }
        } catch (err) {
          alert('Erreur réseau ou serveur.');
        }
      });
    }
  const form = document.getElementById('login-form');
  const header = form?.parentElement;
  const rightsLabels = ['None', 'Scolaire', 'Club', 'Admin'];

  function updateHeaderUI() {
    const carteTab = document.getElementById('tab-carte');
    const listeTab = document.getElementById('tab-liste');
    const adminTab = document.getElementById('tab-admin');
    const path = window.location.pathname.toLowerCase();
    if (carteTab && listeTab) {
      if (path.includes('listing.html')) {
        carteTab.style.background = '#f5f5f5';
        listeTab.style.background = '#e3e6f5';
        if (adminTab) adminTab.style.background = '#f5f5f5';
      } else if (path.includes('admin.html')) {
        if (carteTab) carteTab.style.background = '#f5f5f5';
        if (listeTab) listeTab.style.background = '#f5f5f5';
        if (adminTab) adminTab.style.background = '#e3e6f5';
      } else {
        carteTab.style.background = '#e3e6f5';
        listeTab.style.background = '#f5f5f5';
        if (adminTab) adminTab.style.background = '#f5f5f5';
      }
    }
    // Show Admin tab only if logged in as admin
    try {
      const user = localStorage.getItem('cdco38_user');
      if (adminTab) {
        if (user) {
          const parsed = JSON.parse(user);
          if (typeof parsed.rights === 'number' && parsed.rights === 3) {
            adminTab.style.display = '';
          } else {
            adminTab.style.display = 'none';
          }
        } else {
          adminTab.style.display = 'none';
        }
      }
    } catch {}
  }

  function showGreeting(user) {
    if (!header) return;
    form.style.display = 'none';
    let greet = document.getElementById('user-greeting');
    if (!greet) {
      greet = document.createElement('span');
      greet.id = 'user-greeting';
      greet.style.marginLeft = '18px';
      greet.style.fontWeight = '500';
      greet.style.fontSize = '1em';
      // Insert after login-container for new header structure
      const loginContainer = header.querySelector('.login-container');
      if (loginContainer && loginContainer.nextSibling) {
        header.insertBefore(greet, loginContainer.nextSibling);
      } else {
        header.appendChild(greet);
      }
    }
    greet.textContent = `Bonjour, ${user.nom} ${user.prenom} (${rightsLabels[user.rights] || user.rights})`;
    // Hide login-container
    const loginContainer = header.querySelector('.login-container');
    if (loginContainer) loginContainer.style.display = 'none';
    let logoutBtn = document.getElementById('logout-btn');
    if (!logoutBtn) {
      logoutBtn = document.createElement('button');
      logoutBtn.id = 'logout-btn';
      logoutBtn.textContent = 'Déconnexion';
      logoutBtn.style.marginLeft = '18px';
      logoutBtn.style.padding = '4px 12px';
      logoutBtn.style.borderRadius = '4px';
      logoutBtn.style.border = 'none';
      logoutBtn.style.background = '#c62828';
      logoutBtn.style.color = 'white';
      logoutBtn.style.fontWeight = '500';
      logoutBtn.style.cursor = 'pointer';
      greet.after(logoutBtn);
      logoutBtn.addEventListener('click', async () => {
        await fetch('/api/logout', { method: 'POST' });
        localStorage.removeItem('cdco38_user');
        // Reload the page to reset all state and UI
        window.location.reload();
      });
    }
    updateHeaderUI();
  }

  function checkSession() {
    const user = localStorage.getItem('cdco38_user');
    if (user) {
      showGreeting(JSON.parse(user));
    }
    updateHeaderUI();
  }

  checkSession();

  if (!form) return;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const username = document.getElementById('login-username').value.trim();
    const password = document.getElementById('login-password').value;
    if (!username || !password) {
      alert('Veuillez remplir tous les champs.');
      return;
    }
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const result = await res.json();
      if (result.success && result.user) {
        localStorage.setItem('cdco38_user', JSON.stringify(result.user));
        // Reload the page to reset all state and UI
        window.location.reload();
      } else {
        alert(result.message || 'Identifiants invalides.');
      }
    } catch (err) {
      alert('Erreur réseau ou serveur.');
    }
  });
}

if (typeof window !== 'undefined') {
  window.runLoginLogic = runLoginLogic;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runLoginLogic);
} else {
  runLoginLogic();
}
